import { io, Socket } from 'socket.io-client';

const socket = (): Socket => io('https://conc.multicoisas.com.br:8080');

export default socket;
